import { render } from "./Iscb.vue?vue&type=template&id=7ca09eb1&scoped=true"
import script from "./Iscb.vue?vue&type=script&lang=js"
export * from "./Iscb.vue?vue&type=script&lang=js"

import "./Iscb.vue?vue&type=style&index=0&id=7ca09eb1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca09eb1"]])

export default __exports__